import { createAsyncThunk } from '@reduxjs/toolkit'
import { FetchTeamMemberEventParams, TeamMemberEvent } from './types'
import axios from '../../../config/axios'
import { AxiosError } from 'axios'

export const fetchTeamMemberEvent = createAsyncThunk<TeamMemberEvent, FetchTeamMemberEventParams>(
  'teamMemberEvents/fetchTeamMemberEvent',
  async (params, { rejectWithValue }) => {
    try {
      const response = await axios.get<TeamMemberEvent>('/events/teamMemberEvent', {
        params: {
          teamMemberWorkdayId: params.teamMemberWorkdayId,
          teamMemberEmail: params.teamMemberEmail,
        },
      })
      return response.data
    } catch (error) {
      if (error instanceof AxiosError && error.response) {
        return rejectWithValue(error.response.data)
      }
      return rejectWithValue('An unexpected error occurred')
    }
  },
)
